<template>
  <div>
    <el-menu :class="menuMode === 'vertical' ? 'vertical-menu_container' : 'horizontal-menu_container'"  :default-active="activeMenu" :mode="menuMode" @select="selectMenu">
      <el-menu-item index="messages">消息列表</el-menu-item>
      <el-menu-item index="articles">况客研究</el-menu-item>
      <el-menu-item index="focuses">轮播图</el-menu-item>
      <el-menu-item index="categories">文章分类</el-menu-item>
    </el-menu>
    <div class="data_container">
      <div class="data-header_container">
        <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="createMessage">新建</el-button>
        <el-link class="right-direction" type="info" @click="quitSite"><i class="el-icon-s-custom"></i>退出</el-link>
      </div>
      <div>
        <a v-for="(item,key) in messages" :key="key" :href="item.url" target="_blank" class="article_container">
          <p>
            <span class="article-title_container">{{item.title}}</span>
            <span v-if="!item.isAuthorization" class="article-auth_container">消息通知</span>
          </p>
          <p>
            <span class="article-category_container" v-for="_item in item.category" :key="item.title+'-'+_item">{{_item}}</span>
          </p>
          <p class="article-content_container">{{item.content}}</p>
          <p>
            <span class="article-info_container">{{item.mediums.join(', ')}}</span>
            <span class="article-info_container">{{item.date }}</span>
            <el-button v-if="item.isOpen" icon="el-icon-video-pause" type="text" size="small" class="open-status" @click.native.prevent="toggleRow(item)">暂停</el-button>
            <el-button v-else icon="el-icon-video-play" type="text" size="small" class="close-status" @click.native.prevent="toggleRow(item)">开始</el-button>
            <el-button icon="el-icon-edit" @click.native.prevent="editRow(item)" type="text" size="small">编辑</el-button>
            <el-button
              icon="el-icon-delete"
              type="text"
              size="small"
              class="delete-status"
              @click.native.prevent="deleteRow(key, messages)">
              移除
            </el-button>
          </p>
          <p>
            <span class="article-info_container">{{item.targetUserNames.join(', ')}}</span>
          </p>
        </a>
      </div>
      <el-dialog title="编辑消息" :visible.sync="editDialogStatus">
        <EditMessage :messageData="editDialogData" :submitData="submitData"></EditMessage>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import EditMessage from '../components/EditMessage'
import moment from 'moment'

const mediumMap = {
  '安卓版 App': 'android',
  'iPhone 版 App': 'ios',
  '小程序': 'mini',
  '公众号': 'wechat'
}

const mediumKeys = Object.keys(mediumMap)
const mediumValues = Object.values(mediumMap)

export default {
  name: 'home',
  components: {
    EditMessage
  },
  data () {
    return {
      activeMenu: 'messages',
      menuMode: 'vertical',
      messages: [],
      fofusers: [],
      editDialogStatus: false,
      editDialogData: {
        targetUsers: [],
        title: '',
        content: '',
        url: '',
        priority: 1,
        isReserve: false,
        mediums: ['安卓版 App', 'iPhone 版 App']
      }
    }
  },
  async created () {
    const screenWidth = document.body.clientWidth
    if (screenWidth < 500) {
      this.menuMode = 'horizontal'
    } else {
      this.menuMode = 'vertical'
    }
    const { fofusers } = await this.$http.get('/fofusers/')
    this.fofusers = fofusers
    const resp = await this.$http.get('/messages/')
    if (resp.messages) {
      this.messages = resp.messages
      this.messages = this.messages.map(x => {
        if (x.isReserve) {
          x.date = moment(x.reserveTime).format('YYYY-MM-DD')
          x.time = moment(x.reserveTime).format('HH:mm:ss')
        } else {
          x.date = moment(x.postTime).format('YYYY-MM-DD')
        }
        x.mediums = x.mediums.map(y => mediumKeys[mediumValues.indexOf(y)] || y)
        if (x.targetUsers.length) {
          x.targetUserNames = x.targetUsers.map(x => {
            let name = ''
            this.fofusers.map(y => {
              if (y._id === x) {
                name = y.nickname
              }
            })
            return name
          })
        } else {
          x.targetUserNames = ['所有用户']
        }
        return x
      })
    } else {
      this.$message({
        message: resp.error,
        type: 'warning'
      })
    }
  },
  methods: {
    selectMenu (key, keyPath) {
      if (key !== 'messages') {
        this.$router.push(`/${key}/`)
      }
    },
    quitSite () {
      sessionStorage.clear()
      this.$router.push('/signin/')
    },
    createMessage () {
      this.editDialogData = {
        targetUsers: [],
        title: '',
        content: '',
        url: '',
        priority: 1,
        isReserve: false,
        mediums: ['安卓版 App', 'iPhone 版 App']
      }
      this.editDialogStatus = true
    },
    async postMessage () {
      let { editDialogData } = this

      let resp = null
      if (editDialogData._id) {
        resp = await this.$http.put(`/messages/${editDialogData._id}/`, editDialogData)
      } else {
        editDialogData.type = 'message'
        editDialogData.isOpen = true
        resp = await this.$http.post('/messages/', editDialogData)
      }
      return resp
    },
    async submitData () {
      const resp = await this.postMessage()
      if (resp.message.isReserve) {
        resp.message.date = moment(resp.message.reserveTime).format('YYYY-MM-DD')
        resp.message.time = moment(resp.message.reserveTime).format('HH:mm:ss')
      } else {
        resp.message.date = moment(resp.message.postTime).format('YYYY-MM-DD')
      }
      resp.message.mediums = resp.message.mediums.map(y => mediumKeys[mediumValues.indexOf(y)] || y)
      if (resp.message.targetUsers.length) {
        resp.message.targetUserNames = resp.message.targetUsers.map(x => {
          let name = ''
          this.fofusers.map(y => {
            if (y._id === x) {
              name = y.nickname
            }
          })
          return name
        })
      } else {
        resp.message.targetUserNames = ['所有用户']
      }
      let isCreated = true
      this.messages = this.messages.map(x => {
        if (x._id === resp.message._id) {
          x = resp.message
          isCreated = false
        }
        return x
      })
      if (isCreated) {
        this.messages.unshift(resp.message)
      }
      this.editDialogData = {
        targetUsers: [],
        title: '',
        content: '',
        url: '',
        priority: 1,
        isReserve: false,
        mediums: ['安卓版 App', 'iPhone 版 App']
      }
      this.editDialogStatus = false
      return resp
    },
    async toggleRow (row) {
      row.isOpen = !row.isOpen
      const resp = await this.$http.put(`/messages/${row._id}/`, {
        isOpen: row.isOpen
      })
      if (resp.message) {
      } else {
        this.$message({
          message: resp.error,
          type: 'warning'
        })
      }
    },
    async editRow (row) {
      if (row.isReserve) {
        row.date = moment(row.reserveTime).format('YYYY-MM-DD')
        row.time = moment(row.reserveTime).format('HH:mm:ss')
      }
      row.mediums = row.mediums.map(y => mediumKeys[mediumValues.indexOf(y)] || y)
      this.editDialogData = row
      this.editDialogStatus = true
    },
    async deleteRow (index, rows) {
      const messageId = rows[index]._id
      const resp = await this.$http.delete(`/messages/${messageId}/`)
      if (resp.message) {
        rows.splice(index, 1)
        this.$message({
          message: '移除成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: resp.error,
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vertical-menu_container {
  display: inline-block;
  height: 600px;
  margin: 0 0 50px 0;
  vertical-align: top;
  width: 90px;
}

.horizontal-menu_container {
  margin: 0 0 50px 0;
}

.data_container {
  box-sizing: border-box;
  display: inline-block;
  padding: 0 0 0 20px;
  width: 78%;

  .data-header_container {
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
    overflow: hidden;
    padding-bottom: 10px;
  }

  .right-direction {
    float: right;
  }

  .close-status {
    color: #ccc;
  }

  .delete-status {
    color: #ea4335;
  }
}

p {
  margin: 6px;
}

.article_container {
  background-color: #fefefe;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 4px 4px #fefefe;
  color: #666;
  display: block;
  margin-bottom: 20px;
  min-height: 120px;
  padding: 10px;
  text-decoration: none;

  .article-auth_container {
    color: #34a853;
    display: inline-block;
    font-size: 12px;
    font-style: italic;
    padding: 0 0 0 10px;
  }

  .article-image_container {
    float: right;
    height: 100px;
    vertical-align: top;
  }

  .article-category_container {
    color: #f9bc04;
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    padding: 0 6px 0 0;
  }

  .article-content_container {
    color: #666;
    font-size: 14px;
  }

  .article-info_container {
    color: #aaa;
    display: inline-block;
    font-size: 14px;
    padding: 0 50px 0 0;
  }
}
</style>
